import { Injectable } from '@angular/core';

import { PropertiesOf } from '@skylab-shared/types';
import { FormState } from './form-state';
import { DataHasChangedErrorContext, DataHasChangedErrorHandler } from './form-state-handlers/form-state-data-has-changed-error.service';
import { DataNotFoundContext, DataNotFoundHandler } from './form-state-handlers/form-state-data-not-found-error.service';
import { ExternalErrorHandler } from './form-state-handlers/form-state-external-error.service';
import { FormStateHandler } from './form-state-handlers/form-state-handler';
import { SuccessContext, SuccessHandler } from './form-state-handlers/form-state-success.service';
import { ValidationErrorContext, ValidationErrorHandler } from './form-state-handlers/form-state-validation-error.service';

type StateContext = DataNotFoundContext | SuccessContext | ValidationErrorContext | DataHasChangedErrorContext;

@Injectable({providedIn: 'root'})
export class FormStateManager {
    private readonly stateHandler: Partial<PropertiesOf<FormStateHandler<StateContext>>>;

    private currentState: FormState;
    public constructor(
        successHandler: SuccessHandler,
        dataNotFoundHandler: DataNotFoundHandler,
        validationErrorHandler: ValidationErrorHandler,
        externalErrorhandler: ExternalErrorHandler,
        dataHasChangedErrorHandler: DataHasChangedErrorHandler
    ) {
            this.currentState = FormState.None;
            this.stateHandler = dataNotFoundHandler;

            dataNotFoundHandler
                .setNext(validationErrorHandler)
                .setNext(successHandler)
                .setNext(externalErrorhandler)
                .setNext(dataHasChangedErrorHandler);
    }

    public get state(): FormState {
        return this.currentState;
    }

    public setState(state: FormState, ctx?: StateContext): void {
        this.stateHandler.terminate?.(this.state);
        this.currentState = state;
        this.stateHandler.process?.(this.state, ctx as StateContext);
    }
}
